export interface DataImport {
    id: string;
    axImport: FeatureState;
    cef: FeatureState;
    entity: string;
    hasSettings: boolean | null;
}

/** State of an import feature for a single entity. */
export enum FeatureState {
    /** The entity does not support this feature; the value is read-only and ignored on update. */
    NotSupported = 0,
    Off = 1,
    On = 2,
}

export enum MessageType {
    Information = 0,
    Warning,
    Error,
}

export interface Message {
    message: string;
    type: MessageType;
}

export enum SettingType {
    /** Free-form text stored as-is. */
    String = 0,
    /** An integral number, serialized culture-invariantly. */
    Number = 1,
}

/**
 * A self-describing setting of a data-import entity:
 * a culture-invariant string plus its {@link SettingType}.
 */
export interface EntitySetting {
    /** The value formatted culture-invariantly (e.g. `"12"`, never `"1,5"`). */
    readonly value: string;
    /** The kind of value held. Defaults to {@link SettingType.String} on the server. */
    readonly type: SettingType;
}
